import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, InjectionToken, Input, NgIterable, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Calendar } from '@fullcalendar/angular';
import { CONTAINER_DATA } from 'src/app/modules/shared/injector.token';
import * as moment from 'moment';
import { isObjectBindingPattern } from 'typescript';
import { CrudService } from 'src/app/modules/shared/services/crud.service';
import { PageableModel } from 'src/app/modules/shared/models/pageable.model';
import { AuthQuery } from 'src/app/modules/auth/state/auth.query';
import { UserModel } from 'src/app/modules/auth/models/user.model';
import { StringUtils } from 'src/app/modules/shared/utils/string.utils';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import { UserUtils } from 'src/app/modules/shared/utils/user.utils';
import { ColorUtils } from 'src/app/modules/shared/utils/color.utils';
import { ConfirmationService } from 'primeng/api';
import { SnotifyPosition, SnotifyService } from 'ng-snotify';
import { MessageModel } from 'src/app/modules/crm/modules/messages/models/message.model';
import { GeneralQuery } from '../../state/general.query';
import { GeneralService } from '../../state/general.service';
import { Copy } from '../../utils/deepcopy.utils';

@Component({
  selector: 'app-postit',
  templateUrl: './postit.component.html',
  styleUrls: ['./postit.component.scss']
})
export class PostItComponent implements OnInit {

  errors: HttpErrorResponse | undefined = undefined;
  overlayRef: OverlayRef;

  dragPosition = {x: 0, y: 0};

  messageId: string
  title: string;
  body: string;
  message: any;

  isLoadingEmitter = new EventEmitter<boolean>();

  constructor(@Inject(CONTAINER_DATA) public data: any,
    private crudService: CrudService<any>, private authQuery: AuthQuery, private confirmationService: ConfirmationService,
    private snotifyService: SnotifyService, private _overlay: Overlay, private generalQuery: GeneralQuery, private generalService: GeneralService) {
    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    this.overlayRef = data.overlayRef;
    this.messageId = data.messageId;
    this.title = data.title;
    this.body = data.body;
    this.message = data.message;
  }


  ngOnInit(): void {
    this.dragPosition = {x: -400, y: 200};
    console.log(this.overlayRef.getConfig())
    // this.overlayRef.updatePositionStrategy( this._overlay.position().global().right(`-200px`).top('-200px'))
    // this.overlayRef.updatePosition();

    const obsc = this.generalQuery.selectIsmessagesIdToClose$.subscribe(c => {
      if(this.messageId == c.toString()){
        this.overlayRef.detach();
        this.generalService.setMessagesIdToClose(-1)
      }
    });
  }

  setRead(): void {
    const m = Copy.deep(this.message);
    m.read = !m.read;
    if("from" in m){
      delete m.from.agenzia;
    }
    if("to" in m){
      delete m.to.agenzia;
    }
    const id = "id" in m ? m.id : m.data.id
    this.crudService.update('message/read', id, m)
      // tslint:disable-next-line: deprecation
      .subscribe(
        (data: MessageModel) => {
          this.overlayRef.detach();
        },
        error => {
          this.errors = error;
          this.snotifyService.error(`Errore ${error.message}`, {
            timeout: 2000,
            showProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            position: SnotifyPosition.rightTop
          });
        },
        () => {
        });
  }

}
